import React from "react"
import { Row, Col, Typography } from "antd"
import { useMediaQuery } from "beautiful-react-hooks"

import SevenEleven from "../../images/landing/companies/711.png"
import Cisco from "../../images/landing/companies/cisco.png"
import ColdStorage from "../../images/landing/companies/coldstorage.png"
import Giant from "../../images/landing/companies/giant.png"
import Guardian from "../../images/landing/companies/guardian.png"
import Lazada from "../../images/landing/companies/lazada.png"
import Qxpress from "../../images/landing/companies/qxpress.png"
import RedDoorz from "../../images/landing/companies/reddoorz.png"
import Shopee from "../../images/landing/companies/shopee.png"

import { Swiper, SwiperSlide } from "swiper/react"
import SwiperCore, { Autoplay } from "swiper"

const { Title } = Typography

const Companies: React.FC = () => {
	const isSmall = useMediaQuery("(max-width: 48rem)")
	SwiperCore.use([Autoplay])

	return (
		<Row justify="center" className="mt-100" style={{ padding: 20 }}>
			<Col sm={{ span: 22 }} md={{ span: 22 }}>
				<Title level={3} style={{ textAlign: "center" }}>
					Companies we work with
				</Title>

				<Swiper
					spaceBetween={50}
					slidesPerView={isSmall ? 3 : 6}
					loop
					autoplay={true}
					lazy
				>
					<SwiperSlide>
						<img src={SevenEleven} style={{ width: "100%" }} />
					</SwiperSlide>
					<SwiperSlide>
						<img src={Cisco} style={{ width: "100%" }} />
					</SwiperSlide>
					<SwiperSlide>
						<img src={ColdStorage} style={{ width: "100%" }} />
					</SwiperSlide>
					<SwiperSlide>
						<img src={Giant} style={{ width: "100%" }} />
					</SwiperSlide>
					<SwiperSlide>
						<img src={Guardian} style={{ width: "100%" }} />
					</SwiperSlide>
					<SwiperSlide>
						<img src={Lazada} style={{ width: "100%" }} />
					</SwiperSlide>
					<SwiperSlide>
						<img src={Qxpress} style={{ width: "100%" }} />
					</SwiperSlide>
					<SwiperSlide>
						<img src={RedDoorz} style={{ width: "100%" }} />
					</SwiperSlide>
					<SwiperSlide>
						<img src={Shopee} style={{ width: "100%" }} />
					</SwiperSlide>
				</Swiper>
			</Col>
		</Row>
	)
}

export default Companies
